import { MenuItem as MuiMenuItem, ListItemIcon, Typography } from "@mui/material";

import { If } from "@/features/shared/components";

type Props = {
  icon?: React.ReactNode;
  title: string;
  onClick?: () => void;
  color?: string;
};

export default function MenuItem({ icon, color, title, onClick }: Props) {
  return (
    <MuiMenuItem onClick={() => onClick?.()}>
      <If condition={icon}>
        <ListItemIcon>{icon}</ListItemIcon>
      </If>

      <Typography color={color}>{title}</Typography>
    </MuiMenuItem>
  );
}
